import styled from '@emotion/styled';

/** 샛별 섹션 소제목 — 구간 현황·애셋 목록·적립 내역이 함께 쓴다 */
export const STitle = styled.h3`
  color: ${({ theme }) => theme.color.label.primary};
  ${({ theme }) => theme.font.body1_sb};
`;
